import { z } from 'zod';
// =========================================================
// Schemas Zod del dominio hormigón (catálogos base).
//
// Los schemas de las operaciones legacy de coladas (NuevaColada,
// AsignarBatchAColada, CerrarColadaBc, NuevoCilindro, NuevoEnsayoCilindro)
// se removieron en la sesión que rebuildeó el modelo de coladas (0012):
// estaban alineados al workflow viejo del scaffold y no a la máquina de
// estados del dominio v1.0. Cuando se implementen los endpoints de
// mutación (sesiones 5/6) se redefinen acá con los inputs nuevos.
//
// `ImportarCsvSchema` también queda legacy: el endpoint productivo
// es `POST /api/batches/ingestar` con `IngestaBlendRequestSchema`
// (en `ingesta-blend.ts`).
// =========================================================
export const TipoMaterialSchema = z.enum([
    'arena',
    'piedra_cuartilla',
    'piedra_quintilla',
    'cemento',
    'fibra',
    'aditivo',
    'agua',
]);
export const UnidadMaterialSchema = z.enum(['kg', 'l', 'm3']);
export const EstadoColadaSchema = z.enum([
    'sugerida',
    'confirmada',
    'digitada',
    'cerrada',
    'anulada',
]);
//# sourceMappingURL=hormigon.schema.js.map